import * as React from 'react';
import {FormGroupProps} from "../../common/props/FormGroupProps";
import {PlaceholderProps} from "../../common/props/PlaceholderProps";
import FormGroup from "../../../hiberUiKit/src/molecules/FormGroup/FormGroup";
import {Option} from "ts-option";
import MaskedTextInput from "../../../hiberUiKit/src/atoms/Input/MaskedTextInput";

interface ComponentProps {
	/**
	 * Mask format.
	 */
	mask: Array<string | RegExp>;
	/**
	 * Get final value from string with mask.
	 * @param {string} value
	 * @returns {string}
	 */
	getValue?: (value: string) => string;
}

type Props = ComponentProps & FormGroupProps<string> & PlaceholderProps;

export default class MaskedTextInputFormGroup extends React.Component<Props, {}> {
	render() {
		return (
			<FormGroup label={this.props.label} error={this.props.field.firstError().getOrElse("")}>
				<MaskedTextInput onChange={this.onChange}
								 placeholder={this.props.placeholder}
								 value={this.props.field.value}
								 mask={this.props.mask}/>
			</FormGroup>
		);
	}

	onChange = (value: Option<string>) => {
		const finalValue = this.props.getValue ? value.map(val => this.props.getValue(val)) : value;
		this.props.onChange(this.props.field.updateValue(finalValue));
	}
}
